import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useSearchParams } from "react-router-dom";
import { registerMetadata } from "@/services/metadataEvent";
import { Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "./parcelar-contas-ou-pedir-emprestimo.scss";
import BotaoSimular from "@/components/BotaoSimular";

export default function ParcelarContasOuPedirEmprestimo() {
	const [searchParams] = useSearchParams();
	searchParams.get("__firebase_request_key");

	useEffect(() => {
		const metaData = {};
		metaData.utmSource = searchParams.get("utm_source");
		metaData.utmMedium = searchParams.get("utm_medium");
		metaData.utmCampaign = searchParams.get("utm_campaign");
		metaData.utmId = searchParams.get("utm_id");
		metaData.utmTerm = searchParams.get("utm_term");
		const metadataRegister = {
			...metaData,
			isMobile: isMobile,
			userAction:
				"VIEW_BLOG_PARCELAR_CONTAS_OU_PEDIR_EMPRESTIMO_O_QUE_VALE_MAIS_A_PENA",
			url: window.location.href,
		};

		registerMetadata(metadataRegister, "METADATA_VIEW_SITE_QUITABOLETOS");
	}, [searchParams]);

	return (
		<Container className="sessao-post">
			<Grid
				size={12}
				sx={{
					display: "flex",
					justifyContent: "center",
				}}>
				<Grid container spacing={3} maxWidth="sm" sx={{ py: 3 }}>
					<Grid
						className="logo-blog"
						size={12}
						sx={{
							display: { xs: "none", sm: "flex" },
							justifyContent: "center",
						}}>
						<img
							className="logo-blog-img"
							src="/site/blog/blog_parcelar_contas_ou_pedir_emprestimo__o_que_vale_mais_a_pena.png"
							alt="logo-blog"
						/>
					</Grid>

					<Grid size={12}>
						<Typography variant="h1" sx={{ mt: 2, p: 1 }}>
							Parcelar contas ou pedir empréstimo: o que vale mais a pena?
						</Typography>
					</Grid>

					<Grid size={12}>
						<Typography sx={{ fontSize: 22, fontStyle: "italic" }}>
							Em algum momento da vida, todo mundo já se viu com contas acumuladas, saldo negativo no banco e a sensação de que o mês vai terminar antes do dinheiro. Nessas horas, duas opções costumam aparecer: pedir um empréstimo ou parcelar as contas. Mas afinal, qual dessas alternativas faz mais sentido para quem quer resolver a situação sem complicar ainda mais a vida financeira?
						</Typography>
					</Grid>

					<Grid container spacing={2} sx={{ mx: 1, mt: 2 }}>
						<Grid size={12}>
							<Typography sx={{ fontSize: 24, fontWeight: "bold", mb: 1 }}>
								A diferença entre parcelar e pegar um empréstimo
							</Typography>
						</Grid>
						<Grid size={12}>
							<Typography sx={{ fontSize: 20, mb: 2 }}>
								Pedir um empréstimo pessoal significa contratar um valor fixo com um banco ou instituição financeira, que será depositado na sua conta e pago ao longo de meses, com juros definidos. Esse processo, geralmente, exige análise de crédito, tempo de aprovação e, em muitos casos, envolve tarifas e burocracias
							</Typography>
							<Typography sx={{ fontSize: 20, mb: 2 }}>
								Já <strong>parcelar boletos ou Pix no cartão de crédito</strong> é uma forma mais direta e prática de lidar com as dívidas atuais. Em vez de receber o valor para depois quitar suas contas, você já paga o boleto ou o Pix à vista e transforma isso em parcelas acessíveis, direto na fatura do seu cartão. E se for pela <span className="quita">Quita</span>, você ainda faz tudo isso de forma 100% digital, sem precisar comprovar renda, com total transparência em cada etapa.
							</Typography>
						</Grid>

						<Grid size={12}>
							<Typography sx={{ fontSize: 24, fontWeight: "bold", mb: 1 }}>
								Vantagens de parcelar contas com a Quita Boletos
							</Typography>
						</Grid>
						<Grid size={12}>
							<ul className="lista">
								<li>📌<span className="titulo-lista">Sem burocracia e sem análise de crédito</span> <br />
									Não importa se você está negativado: se tiver limite no cartão, você consegue parcelar. Nada de score alto como pré-requisito.</li>
								<li>📌<span className="titulo-lista">Transparência e controle</span> <br />
									Na simulação da <span className="quita">Quita</span>, você vê exatamente quanto vai pagar em cada parcela — sem letrinhas miúdas ou taxas escondidas.
								</li>
								<li>📌<span className="titulo-lista">Agilidade e praticidade</span> <br />
									Você faz tudo pelo celular, em minutos. E já sai com o boleto ou Pix pago.
								</li>
								<li>📌<span className="titulo-lista">Liberdade para escolher o número de parcelas</span> <br />
									Se não cabe no mês, a <span className="quita">Quita</span> parcela em até 12x — e você escolhe o que faz mais sentido pro seu bolso.
								</li>
								<li>📌<span className="titulo-lista">Solução para imprevistos, sem virar uma bola de neve</span> <br />
									Enquanto o empréstimo muitas vezes resolve uma coisa e cria outra, o parcelamento resolve o problema real: o boleto vencido, o Pix urgente, o aluguel atrasado.
								</li>
							</ul>
						</Grid>
						<Grid size={12}>
							<Typography sx={{ fontSize: 24, fontWeight: "bold", mb: 1 }}>
								Quando o empréstimo pode ser necessário?
							</Typography>
						</Grid>
						<Grid size={12}>
							<Typography sx={{ fontSize: 20 }}>
								É verdade que o crédito pessoal pode ser útil em alguns casos — como no financiamento de algo maior, que exige uma quantia alta de imediato. Mas para quem precisa resolver pendências específicas, com valores mais pontuais e urgentes, o parcelamento pode ser uma alternativa mais leve, com menos impacto psicológico e financeiro.
							</Typography>
						</Grid>

						<Grid size={12}>
							<Typography sx={{ fontSize: 24, mb: 1 }}>
								Então, o que vale mais a pena?
							</Typography>
						</Grid>
						<Grid size={12}>
							<Typography sx={{ fontSize: 20, mb: 1 }}>
								Se o objetivo é organizar a vida sem se afundar em mais dívidas, o parcelamento com a <span className="quita">Quita Boletos</span> oferece uma solução simples, segura e justa. É a mão na roda que ajuda a quitar contas sem abrir mão da sua tranquilidade.
							</Typography>
							<Typography sx={{ fontSize: 20, mb: 1 }}>
								Em vez de viver de susto em susto, você pode escolher viver o agora com mais paz.
							</Typography>
							<Typography sx={{ fontSize: 20, mb: 1 }}>
								O parcelamento <span className="quita">Quita</span>. Cabe no seu bolso. Cabe na sua vida.
							</Typography>
						</Grid>

						<Grid size={12} align="center">
							<BotaoSimular>CLIQUE AQUI E REALIZE UMA SIMULAÇÃO</BotaoSimular>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
}
